import React,{Fragment, PureComponent, } from 'react'
import {Modal, Button, Popover, Timeline,Spin, Empty} from "antd";
import PropTypes from 'prop-types';
import {isEmpty,isEmptyObject} from "@utils/utils";
import CopyInput from "@components/CopyAndPaste/CopyInput";
import Lang from "@/components/Lang/Lang";
import HoverIcon from "@components/HoverIcon";
import LogisticsService from "./Logistics.action";
import './Index.less';
import dayjs from 'dayjs';
/**
 * 查看 物流信息组件 |（内部外部柜号切换）
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2022, all rights reserved. Essa.cn
 *
 * @showSimpleIcon 是否展示简单的：传入子节点，否 则展示带提示的物流图标
 * 示例 https://oss.essaone.com/16521e7c-fa6f-4cb7-bb32-fb6dc5861213.png
 *
 * // 两者必传一个
 * @poId
 * @logisticsData
 **/
class LogisticsInformation extends PureComponent {
    static propTypes = {
        // logisticsData: PropTypes.array.isRequired,
        poCode: PropTypes.string,
        showSimpleIcon: PropTypes.bool,
    }
    static defaultProps = {
        logisticsData: [],
        poCode:'',
        showSimpleIcon: false,
        leftCode:'',
        rightCode:'',
        poId:"",
        showPoOutInfo:true,//显示po物流出货信息 物流方式 物流LOGO 物流单号
    };
    constructor(props) {
        super(props);
        this.state = {
            showModalLogistics: false,
            consignee:{
                // city: "符拉迪沃斯托克(海参崴) ",
                // address:"符拉迪沃斯托克(海参崴) 仓库地址地址符拉迪沃斯托克(海参崴) 仓库地址地址符拉迪沃斯托克(海参崴) 仓库地址地址符拉迪沃斯托克(海参崴) 仓库地址地址",
                // remark:"符拉迪沃斯托克(海参崴) 仓库地址地址符拉迪沃斯托克(海参崴) 仓库地址地址符拉迪沃斯托克(海参崴) 仓库地址地址符拉迪沃斯托克(海参崴) 仓库地址地址",
                // time:"9:00 - 18:00",
                // contacts:" 张三",
                // tel:"+7 123012932"
            },
            logisticsData:[],
            loading:false,
        }
    }
    /**
     * 加载状态
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /** 打开物流信息弹窗*/
    openModalLogistics(flag=false,list=[]) {
        this.setState({
            showModalLogistics: flag,
        })
        if(flag){
            const {poId} = this.props;
            if(!isEmpty(poId)){
                this.loading(true);
                LogisticsService.fetch({
                    poId:poId
                }).then(res=>{
                    this.loading(false);
                    const dat = res.data||{};
                    const {success,valid, model } = dat;
                    if (success &&valid) {
                        const data = model || {}
                        const consignee = {
                            city: data.transitCityName,
                            address: data.addrLandCode ? Lang({id: data.addrLandCode}) : "",
                            time: (data.workStartTime || "") + " - " + (data.workEndTime || ""),
                            contacts: data.managerName || "",
                            tel: (data.telCode || "") + " " + (data.mobile || "")
                        }
                        this.setState({
                            // showModalLogistics: true,
                            logisticsData: data.pubOrderTrackVOS || [],
                            poCode: data.poCode,
                            leftCode: data.containerCode,
                            rightCode: data.cabinetNum,
                            consignee: consignee,
                            abdWhsDeliveryOrderVO: data.abdWhsDeliveryOrderVO || {}
                        })
                    }
                })
            }
        }
    }
    stepItem(item={},index) {
        return (
            <div className="fw_400 font_14" key={"item_key_"+index}>
                <p className={"black89 mb_4"}>
                    <span className="mr_6">{item.trackTime&&dayjs(item.trackTime).format('YYYY-MM-DD')}</span>
                    <span>{item.trackTime&&dayjs(item.trackTime).format('HH:mm:ss')}</span>
                </p>
                <p className="black66" style={{lineHeight: '18px',}}>{item.trackDesc}</p>
            </div>
        )
    }
    renderChild(list=[]){ 
        let childList = []
        list.forEach((item={},inx)=>{
            childList.push({
                children: this.stepItem(item),
                color: inx==0?'red':'gray',
            })
        }) 
        return childList
    }
    // 渲染物流
    renderCom(logisticsCompanyInfo={},logisticsCompanyName=""){
        return (logisticsCompanyInfo.logoFileUrl?<div className={"logo logoImg"}>
            <img src={logisticsCompanyInfo.logoFileUrl} />
        </div>:<div className={"logo"}>{logisticsCompanyInfo.name||logisticsCompanyName}</div>)
    }
    componentWillMount() {

    }
    componentDidMount() {
        if( this.props.onRef)  this.props.onRef(this);
    };
    render() {
        const { showSimpleIcon,children, showPoOutInfo,}=this.props;
        const {  poCode,leftCode, rightCode,showModalLogistics,consignee,logisticsData, loading,abdWhsDeliveryOrderVO} = this.state;
        return (<Fragment>
            {showSimpleIcon?<span onClick={()=>this.openModalLogistics(true)} >{children}</span>:<Popover content={Lang({id: 'WuLiuXinXi',default:'物流信息'})}>
                <div className={"icon_logistics_inline"} onClick={()=>this.openModalLogistics(true)}>
                    <HoverIcon
                        inactiveIcon="icon-wuliuxinxi"
                        activeIcon="icon-wuliuxinxi-xuanzhong"></HoverIcon>
                </div>
            </Popover>}
            {showModalLogistics&&<Modal open={showModalLogistics}
                                        width={600}
                                        closable={false}
                                        title={Lang({id: 'WuLiuXinXi',default:'物流信息'})}
                                        onCancel={() =>this.openModalLogistics(false,[])}
                                        footer={[<Button key="close" type="primary"
                                                         onClick={() => {this.setState({
                                                             showModalLogistics: false,
                                                         })
                                                         }}  >
                                            {Lang({id: 'GuanBi',default:'关闭'})}
                                        </Button>]}>
                <div className={"pop-logistics-wrap"}>
                    {poCode&&<div className="black89 font_48 mb_12">{poCode}</div>}
                    {/* 提货方式 */}
                    {showPoOutInfo&&!isEmptyObject(abdWhsDeliveryOrderVO)&&<>
                        {abdWhsDeliveryOrderVO.type=="10"?<div className={"black89 pickWrapAuto mb_12 flex-item-ver-center"}>
                            <span className="ri-truck-line mr_8 font_24" />
                            <span className={"fw_700 font_14"}>{abdWhsDeliveryOrderVO.typeName}</span>
                        </div>:<div className={"pickWrap mb_12"}>
                            <p className={"mb_4 flex-item-ver-center black89"}>
                                <span className="ri-truck-line mr_8 font_24" />
                                <span className={"fw_700 font_14"}>{abdWhsDeliveryOrderVO.typeName}</span>
                            </p>
                            {/* type	10:个人自提 20:第三方公司 30:配送*/}
                            {(abdWhsDeliveryOrderVO.type=="20"||abdWhsDeliveryOrderVO.type=="30")&&this.renderCom(abdWhsDeliveryOrderVO.logisticsCompanyInfo,abdWhsDeliveryOrderVO.logisticsCompanyName)}
                            {/* 单号  */}
                            {abdWhsDeliveryOrderVO.logisticsNumber?<p className={"black89 mt_8 flex-item-ver-center"}>
                                <span className={"font_16 fw_700 "}>
                                   {Lang({id:"DanHao",default:"单号"})}
                                    <span className={"ml_4"}>{abdWhsDeliveryOrderVO.logisticsNumber}</span>
                                </span>
                                <CopyInput value={abdWhsDeliveryOrderVO.logisticsNumber} optionId={'lo_input_copy_logisticsNumber'} />
                            </p>:null}
                        </div>}
                    </>}
                    <div className={"flex-item-between"}>
                        {leftCode&&<div className={'info-code mr_4'}>
                                <p className="font_16">
                                    <i className="ri-archive-drawer-line color-green margin-right-5"></i>
                                    <span className={"font_14 black89 font-bold"}>{Lang({id: 'NeiBuGuiHao',default:'内部柜号'})}</span>
                                </p>
                                <div className={"flex-item-between"}>
                                    <div className="black66 copyWidth ellipsis">{leftCode}</div>
                                    <CopyInput value={leftCode} optionId={'lo_input_copy_left'} />
                                </div>
                            </div>}
                        {rightCode&&<div className={'info-code bg-blue ml_6'}>
                                <p className="font_16">
                                    <span className="color-blue ri-ship-2-line margin-right-5"></span>
                                    <span className={"font_14 black89 font-bold"} >{Lang({id: 'WuLiuGuiHao',default:'物流柜号'})}</span>
                                </p>
                                <div className={"flex-item-between"}>
                                    <div className="black66 copyWidth ellipsis" id={'Input_Copy_right'}>{rightCode}</div>
                                    <CopyInput value={rightCode} optionId={'lo_input_copy_right'}/>
                                </div>
                            </div>}
                    </div>
                    {/* 仓库地址 */}
                    <Spin spinning={loading}>
                    <div className={"addressWrap mt_12 mb_12"}>
                        <p className={"black89 mb_12"}>
                            <i className="ri-building-line mr_8 font-18"></i>
                            <span className={"font-bold"}>{consignee.city}</span>
                        </p>
                        <p className={"mb_24"}>{consignee.address}</p>
                        <p className={"mb_4"}>{Lang({id: 'GongZuoShiJian',default:'工作时间'})} {consignee.time}</p>
                        <p>{Lang({id: 'LianXiXinXi',default:'联系信息'})} {consignee.tel}<span className={"ml_8"}>{consignee.contacts}</span></p>
                    </div>
                    {logisticsData.length>0?<div className={'modalLogisticsWrap'} style={{padding: '10px'}}>
                        <Timeline items={this.renderChild(logisticsData)} />
                    </div>:<Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE} description={Lang({id: 'ZanWuWuLiuShuJu',default:'暂无物流数据'})} />}
                    </Spin>
                </div>
            </Modal>}
        </Fragment>);
    }
}

export default LogisticsInformation;
